import Experience from '..'

export default class NavigationManager {
  private experience = new Experience()

  private resetScene = false

  public step = 0

  constructor() {
    this.updateGUI = this.updateGUI.bind(this)
  }

  private updateGUI() {
    const cameraBtn = document.getElementById('camera-btn')
    const handPrompt = document.getElementById('hand-prompt')

    if (cameraBtn && handPrompt) {
      cameraBtn.style.display = 'none'
      cameraBtn.style.opacity = '0'
      cameraBtn.style.pointerEvents = 'auto'

      handPrompt.style.display = 'none'
      handPrompt.style.opacity = '0'
      handPrompt.style.pointerEvents = 'auto'
    }
  }

  public update(step: number) {
    this.step = step // update experience step

    switch (step) {
      case 0: {
        if (this.resetScene) {
          this.experience.camera.start()
          this.experience.world.shark.reset()

          this.resetScene = false

          this.experience.world.squiggles?.hide()
        }
        break
      }
      case 1: {
        this.experience.world.shark.free()
        this.updateGUI()
        this.experience.world.squiggles?.show()

        this.resetScene = true
        break
      }
      default:
    }
  }
}
